const withLocalStorage =
  fn =>
  (...params) => {
    if (window && window.localStorage) {
      return fn(localStorage)(...params);
    }
    return null;
  };

export const setItem = localStorage => (key, value) => {
  localStorage.setItem(key, value);
};

export const getItem = localStorage => key => localStorage.getItem(key);

export const removeItem = localStorage => key => {
  localStorage.removeItem(key);
};

export const extractItem = localStorage => key => {
  const value = localStorage.getItem(key);
  localStorage.removeItem(key);

  return value;
};

export default {
  setItem: withLocalStorage(setItem),
  getItem: withLocalStorage(getItem),
  removeItem: withLocalStorage(removeItem),
  extractItem: withLocalStorage(extractItem)
};
